import { render, staticRenderFns } from "./RegisterAfter.vue?vue&type=template&id=be03510e&scoped=true"
import script from "./RegisterAfter.vue?vue&type=script&lang=js"
export * from "./RegisterAfter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be03510e",
  null
  
)

export default component.exports